import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ScrollBottom from "../../shared/components/ScrollBottom/ScrollBottom.vue";
import { Http } from "@status/codes";
import ListItem from "@/shared/components/ListItem/ListItem.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import {
  CATEGORIES,
  CATEGORY_LIST,
  CHART_INIT,
  CHART_TITLE,
  SESSIONS_FILTERS,
  SESSION_TEMPLATES_ACCESS,
  SESSION_TEMP_CONSTANTS
} from "./constants/SessionTemplateConstants";
import { SessionTemplateService } from "./services/SessionTemplateService";
import { SessionTemplateHeader } from "./models/SessionTemplateHeader";
import { Response } from "@/shared/models/Response";
import { SessionQuery } from "./models/SessionQuery";
import ViewIframeModal from "@/shared/components/ViewIframeModal/ViewIframeModal.vue";
import {
  GENERAL_CONSTANTS,
  KEYTYPE_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { SearchContext } from "@/shared/models/SearchContext";
import store from "@/store";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import SaveSessionTemplate from "./components/SaveSessionTemplate/SaveSessionTemplate.vue";
import { CrudChartData } from "@/shared/models/CrudChartData";
import { Utils } from "@/shared/utils/utils";
import { ChartRenderData } from "../Dashboards/AdminDashboard/models/ChartRenderData";
import { CrudChartRenderData } from "../Dashboards/AdminDashboard/models/CrudChartRenderData";
import CrudChart from "@/shared/components/CrudChart/CrudChart.vue";
import { ListService } from "../List/services/ListService";
import { LACK_OF_OPTIONS } from "../Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import { AmountSessionsByCategory } from "./models/SessionAmountByCategory.model";
import { SessionTemplateWithChartPagination } from "./models/sessionTemplatePaginationWithChart.model";
import { LIST_ACCESS } from "../List/constants/ListConstants";

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "SessionTemplate",
  components: {
    CrudChart,
    EmptyState,
    ScrollBottom,
    ObservationModal,
    ModalTemplate,
    ListItem,
    ViewIframeModal,
    SaveSessionTemplate
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class SessionTemplate extends Vue {
  @Inject() sessionTemplateService!: SessionTemplateService;
  @Inject() listService!: ListService;

  dataToMainView!: MenuDataStructure;
  SESSION_TEMP_CONSTANTS = SESSION_TEMP_CONSTANTS;
  /* eslint-disable-next-line  @typescript-eslint/no-empty-function */
  callbackHandleContextPanel: Function = () => {};

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  secondaryBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  cardClass = STYLE_CLASSES.CARD;
  tooltip = SESSION_TEMP_CONSTANTS.BUTTON.ADD_SESSION_TEMP;

  EMPTY_STATE_HEADER = FORM_MESSAGES.INFO_MESSAGE.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = FORM_MESSAGES.INFO_MESSAGE.EMPTY_STATE_TEXT;
  PAGE_TITLE = SESSION_TEMP_CONSTANTS.PAGE_TITLE_SEARCH;
  CLOSE_BTN = FORM_CONSTANTS.BUTTON.CLOSE;
  OPERATIONS = [LIST_DATA_EVENTS.VIEW_DATA];
  CLICK_ACTION = LIST_DATA_EVENTS.EDIT_DATA;
  EMPTY_STATE = FORM_MESSAGES.INFO_MESSAGE;

  multimediaPath = "";
  showCardsContainer = false;
  loadingData = false;
  sessionsList: SessionTemplateHeader[] = [];
  dataSession!: Response<SessionTemplateWithChartPagination>;
  idReference = "";
  canSearch = true;
  viewDialog = false;
  playbook = "";
  filterQuery: SessionQuery = {};
  sessionToEdit = "";
  isVisibleSaveSessionTemplate = false;
  showCharts = false;
  action = SESSION_TEMP_CONSTANTS.ACTIONS.CREATE;
  dataToChart?: CrudChartRenderData = CHART_INIT;
  chartDataGroupName: ChartRenderData = {
    labels: [],
    datasets: [
      {
        data: []
      }
    ]
  };
  filterArray = SESSIONS_FILTERS.MAIN;

  admin = false;
  flatSearch = false;

  mounted() {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);

    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.ADMIN_ROLE
      )
    ) {
      this.admin = true;
    }

    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.SESSION_TEMPLATE
    );

    this.emitSearchInitializer();
    this.searchData(true);
  }

  async clickData(event: string) {
    const response = await this.getDataByFilter(false, true, {
      category: [event]
    });

    if (response.code === Http.Found && response.data !== undefined) {
      this.getCharts(response.data.dataChart);
      this.showCharts = true;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        response.data.sessionTemplates
      );
    } else {
      this.showCharts = false;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.RESET_SEARCH_CONTEXT
      );
      Snackbar.popError(response.message);
    }
  }

  async clickOut() {
    const response = await this.getDataByFilter(false, true, {});
    if (response.code === Http.Found && response.data !== undefined) {
      this.showCharts = true;
      this.getCharts(response.data.dataChart);
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        response.data.sessionTemplates
      );
    } else {
      this.showCharts = false;
      Snackbar.popError(response.message);
    }
  }

  async getListDataById(id: string) {
    try {
      const responseData = await this.listService.getListById(id);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const listDataList: List[] = [];
        const dataList = responseData.data.optionsSchema as {
          title: string;
        }[];
        dataList.forEach(item =>
          listDataList.push({ key: item.title, name: item.title })
        );

        return listDataList;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      return undefined;
    }
  }

  @Watch("dataToMainView")
  dataToMainViewHandler(
    newValue: MenuDataStructure,
    oldValue: MenuDataStructure
  ) {
    const validations: Record<string, void> = {
      Panel: this.panelValidation()
    };
    validations[this.dataToMainView.from];
    if (newValue.data !== oldValue.data) {
      this.idReference = "";
      this.filterQuery.idReference = this.idReference;
    }
    this.searchData(true);
  }

  panelValidation() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH
    ) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.FUNTION_MODAL:
          this.callbackHandleContextPanel = this.dataToMainView.data;
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          this.createSessionTemplate(this.action);
          this.handleRefresh();
          break;
      }
    }
    if (this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH) {
      if (
        this.dataToMainView.action ===
        PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE
      ) {
        this.searchData(true);
      }
    }
  }

  sendDataToLateralMenu(action: string, data?: unknown) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  async emitSearchInitializer() {
    await this.initializeFilters();

    const searchContext: SearchContext = {
      title: this.PAGE_TITLE,
      filterArray: [this.filterArray],
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      componentName: COMPONENT_NAME_MODAL.SESSION_TEMPLATE,
      callbackHandleOperation: this.handleOperation,
      descriptions: [CATEGORIES, SESSIONS_FILTERS.SECONDARY.STATUS.key],
      textButtonCreate: SESSION_TEMP_CONSTANTS.BUTTON.ADD_SESSION_TEMP
    };

    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      searchContext
    );
  }

  async initializeFilters() {
    this.filterArray.secondaryFilters = [];
    this.filterArray.secondaryFilters.push(SESSIONS_FILTERS.SECONDARY.NAME);
    this.filterArray.secondaryFilters.push(SESSIONS_FILTERS.SECONDARY.STATUS);
    const responseCategories = await this.getListDataById(CATEGORY_LIST);
    if (responseCategories !== undefined) {
      SESSIONS_FILTERS.SECONDARY.CATEGORY.options = responseCategories as any;
      this.filterArray.secondaryFilters.push(
        SESSIONS_FILTERS.SECONDARY.CATEGORY
      );
    }
  }

  handleRefresh() {
    this.idReference = "";
    this.sessionsList = [];
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.VIEW_DATA:
        await this.viewSessionTemplate(itemId);
        await this.handleRefresh();
        break;
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.editSessionTemplate(itemId);
        await this.handleRefresh();
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        await this.deleteService(itemId);
        this.cancelData();
        await this.handleRefresh();

        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateSessionTemplate(itemId, STATE.ACTIVE);
        this.cancelData();
        await this.handleRefresh();

        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateSessionTemplate(itemId, STATE.INACTIVE);
        this.cancelData();
        await this.handleRefresh();

        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        this.cancelData();
        await this.handleRefresh();

        break;
    }
  }

  cancelData() {
    this.tooltip = SESSION_TEMP_CONSTANTS.BUTTON.ADD_SESSION_TEMP;
    this.action = SESSION_TEMP_CONSTANTS.ACTIONS.CREATE;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL
    );
    this.isVisibleSaveSessionTemplate = false;
  }

  async updateStateSessionTemplate(id: string, state: string) {
    try {
      const responseData = await this.sessionTemplateService.updateStateSessionTemplateById(
        id,
        state
      );
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        await this.searchData(true);
      } else Snackbar.popError(responseData.message);
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SESSION_TEMPLATES_ACCESS.PUT}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async viewSessionTemplate(sessionId: string) {
    try {
      const response = await this.sessionTemplateService.getSessionTemplateById(
        sessionId
      );

      if (response.code === Http.Found && response.data) {
        this.multimediaPath = response.data.multimedia.multimediaPath!;
        this.viewDialog = true;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SESSION_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  editSessionTemplate(sessionId: string) {
    this.action = SESSION_TEMP_CONSTANTS.ACTIONS.CANCEL;
    this.isVisibleSaveSessionTemplate = true;
    this.sessionToEdit = sessionId;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
    this.tooltip = SESSION_TEMP_CONSTANTS.BUTTON.CANCEL;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
      sessionId
    );
  }

  async searchData(shouldSearch: boolean) {
    this.loadingData = true;
    this.showCardsContainer = false;
    this.canSearch = false;
    const filterIfQuery =
      this.filterQuery.name ||
      this.filterQuery.state ||
      this.filterQuery.category;

    if (shouldSearch) {
      this.dataSession = await this.getDataByFilter(
        true,
        true,
        this.dataToMainView.data
      );
      if (this.dataSession.code === Http.BadRequest) {
        if (this.dataSession.data?.sessionTemplates.length == 0) {
          this.loadingData = false;
          return;
        } else {
          this.sendDataToLateralMenu(
            PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
            this.sessionsList
          );
          this.loadingData = false;
          return;
        }
      }
      if (
        this.dataSession.code === Http.Found &&
        this.dataSession.data !== undefined
      ) {
        this.showCharts = true;
        if (filterIfQuery) {
          this.idReference = this.dataSession.data.docref;
          this.sessionsList = this.dataSession.data.sessionTemplates;
          this.flatSearch = true;
          this.sendDataToLateralMenu(
            PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
            this.sessionsList
          );
          this.loadingData = false;
          return;
        }
        if (
          this.idReference != this.dataSession.data.docref &&
          !this.flatSearch
        ) {
          if (this.dataSession.data.sessionTemplates.length != 0) {
            this.idReference = this.dataSession.data.docref;

            this.sessionsList = [
              ...this.sessionsList,
              ...this.dataSession.data.sessionTemplates
            ];
            this.sessionsList = this.sessionsList.filter(
              (item, index, self) =>
                index === self.findIndex(t => t.id === item.id)
            );

            this.canSearch = true;
            this.getCharts(this.dataSession.data.dataChart);
            this.sendDataToLateralMenu(
              PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
              this.sessionsList
            );
          }
        } else {
          this.flatSearch = false;
          this.sessionsList = this.dataSession.data.sessionTemplates;
        }
      }
    }
    this.loadingData = false;
  }

  async getDataByFilter(
    loadPages?: boolean,
    newFilter?: boolean,
    querySearch?: SessionQuery
  ): Promise<Response<SessionTemplateWithChartPagination>> {
    try {
      if (newFilter) this.sessionsList = [...this.sessionsList];

      if (typeof querySearch !== KEYTYPE_CONSTANTS.UNDEFINED) {
        this.filterQuery = {
          name: querySearch?.name ? querySearch?.name : undefined,
          state: querySearch?.state ? querySearch?.state : undefined,
          category: querySearch?.category ? querySearch?.category : undefined
        };
        Object.keys(this.filterQuery).forEach(key => {
          if (this.filterQuery[key as keyof SessionQuery] === undefined) {
            delete this.filterQuery[key as keyof SessionQuery];
          }
        });
      }

      if (loadPages) this.filterQuery.idReference = this.idReference;

      const responseData = await this.sessionTemplateService.getSessionTemplatesWithFilter(
        this.filterQuery
      );

      responseData.data!.sessionTemplates.forEach((item, index) => {
        if (
          responseData.data!.sessionTemplates[index].categories !== undefined
        ) {
          responseData.data!.sessionTemplates[
            index
          ].categories = responseData.data!.sessionTemplates[
            index
          ].categories!.toString();
        }
      });
      return responseData;
    } catch (error) {
      const RESPONSE_ERROR: Response<SessionTemplateWithChartPagination> = {
        code: Http.BadRequest,
        message:
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SESSION_TEMPLATES_ACCESS.GET}`
            : SESSION_TEMP_CONSTANTS.MESSAGE.NOT_FOUND_TEMPLATES
      };
      return RESPONSE_ERROR;
    }
  }

  async deleteService(id: string) {
    try {
      const responseData = await this.sessionTemplateService.deleteServiceTemp(
        id
      );

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        await this.searchData(true);
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  closeIframe() {
    this.viewDialog = false;
  }

  callCancelModal() {
    this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL);
  }

  createSessionTemplate(accion: string) {
    if (accion === SESSION_TEMP_CONSTANTS.ACTIONS.CREATE) {
      this.action = SESSION_TEMP_CONSTANTS.ACTIONS.CANCEL;
      if (this.isVisibleSaveSessionTemplate) {
        this.sessionToEdit = "";
        this.callCancelModal();
      } else {
        this.sessionToEdit = "";
        this.isVisibleSaveSessionTemplate = true;
        this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
        this.tooltip = SESSION_TEMP_CONSTANTS.BUTTON.CANCEL;
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL
        );
      }
      return;
    }
    this.callCancelModal();
    this.action = SESSION_TEMP_CONSTANTS.ACTIONS.CREATE;
  }

  getCharts(chartData: AmountSessionsByCategory[]) {
    const categories: { [key: string]: number } = {};
    if (chartData.length > 0) {
      for (const value of chartData) {
        categories[value.category] = value.sessions;
      }
    }
    const dataChart: CrudChartData = {
      categories: categories
    };

    this.chartDataGroupName = Utils.mapChartData(dataChart, CATEGORIES);
    this.dataToChart = {
      chartTitle: CHART_TITLE,
      chartRenderData: this.chartDataGroupName
    };
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  closeForm() {
    this.sessionToEdit = "";
    this.isVisibleSaveSessionTemplate = false;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.isVisibleSaveSessionTemplate = false;
    this.tooltip = SESSION_TEMP_CONSTANTS.BUTTON.ADD_SESSION_TEMP;
    this.handleRefresh();
    this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.UNDO_SELECTED_ITEM);
    this.action = SESSION_TEMP_CONSTANTS.ACTIONS.CREATE;
  }
}
